import UserSVG from "@design-system/ui-icons/vanilla/User"
import { createIcon } from "../createIcon"

export const UserIcon = createIcon(UserSVG)
